import { useEffect } from 'react'
import { Link, useRouteError } from 'react-router'
import { Compass, RefreshCw, TriangleAlert } from 'lucide-react'
import { Button } from '../components/ui/Button.jsx'
import { Card, Container, EmptyState } from '../components/ui/primitives.jsx'
import { PageHeader } from '../layout/PageHeader.jsx'
import { isStaleBuildError, reloadForNewBuild } from '../lib/staleBuild.js'

export function NotFoundPage() {
  return (
    <>
      <title>Page not found · Pred Hub</title>
      <PageHeader eyebrow="404" title="Page not found" description="That link doesn’t go anywhere on the hub." seed="not-found" />
      <Container>
        <Card>
          <EmptyState
            icon={Compass}
            title="Let’s get you back on the map"
            action={
              <Button as={Link} to="/">
                Go to the hub
              </Button>
            }
          />
        </Card>
      </Container>
    </>
  )
}

// Shown instead of a page that failed to open. Usually that's a tab left
// open across a deploy, so it reloads once on its own to get the new build;
// otherwise it's a bug, and reloading is still the best first step.
export function RouteErrorPage() {
  const error = useRouteError()
  const stale = isStaleBuildError(error)
  useEffect(() => {
    if (stale) reloadForNewBuild()
  }, [stale])
  return (
    <Container className="py-16">
      <title>{stale ? 'Pred Hub was updated · Pred Hub' : 'Something went wrong · Pred Hub'}</title>
      <Card>
        <EmptyState
          icon={stale ? RefreshCw : TriangleAlert}
          title={stale ? 'Pred Hub was just updated' : 'This page couldn’t open'}
          action={
            <div className="flex flex-wrap justify-center gap-2">
              <Button onClick={() => window.location.reload()}>
                <RefreshCw aria-hidden="true" className="size-4" /> Reload
              </Button>
              <Button as={Link} to="/" variant="secondary" reloadDocument>
                Go to the hub
              </Button>
            </div>
          }
        >
          {stale ? 'Reload to get the latest version.' : 'Try reloading. If it keeps happening, let us know what you were doing.'}
        </EmptyState>
      </Card>
    </Container>
  )
}
